'use strict';

angular.module('app').factory("searchConfig", function(gettextCatalog) {
    return {
        MAP_CONFIG: {
            center: {
                lat: 55,
                lng: 38,
                zoom: 4
            },
            defaults: {
                scrollWheelZoom: false,
                zoomControlPosition: 'topright',
                worldCopyJump: true
            },
            layers: {
                baselayers: {
                    test: {
                        name: gettextCatalog.getString('Satellite'),
                        url: '//server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
                        type: 'xyz',
                        subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
                    },
                    mapbox_light: {
                        name: gettextCatalog.getString('PADI Travel Map'),
                        url: 'https://api.mapbox.com/styles/v1/mapbox/light-v9/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiZGl2aWFjIiwiYSI6ImNiZjU5MGVlY2VkZmQ4YWFkNGJmMWVjMDVjMDUzNDdlIn0.62dEH0gmRXAGO5e2x1JnRg',
                        type: 'xyz'
                    }
                }
            }
        },
        STAR_RATING: [1, 2, 3, 4, 5],
        GUESTS_RATING: [{
            id: 3,
            title: "3+"
        }, {
            id: 4,
            title: "4+"
        }, {
            id: 5,
            title: "5+"
        }],
        RESORT_SIZE: [{
                id: 1,
                total_number_of_rooms_0: 0,
                total_number_of_rooms_1: 20,
                title: gettextCatalog.getString("<20 rooms")
            }, {
                id: 2,
                total_number_of_rooms_0: 20,
                total_number_of_rooms_1: 100,
                title: gettextCatalog.getString("20 - 100 rooms"),
            },
            {
                id: 3,
                total_number_of_rooms_0: 100,
                total_number_of_rooms_1: Infinity,
                title: gettextCatalog.getString(">100 rooms")
            }
        ],
        SORT_BY: [{
            title: gettextCatalog.getString('Recommended'),
            value: '-travel_featured_rating',
        }, {
            title: gettextCatalog.getString('Cheapest'),
            value: 'price_sum',
        }, {
            title: gettextCatalog.getString('Best guest ratings'),
            value: '-tripadvisor_rating',
        }, {
            title: gettextCatalog.getString('Highest hotel category'),
            value: '-stars',
        }]
    }
    
});